/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * response of DELETE /prtimes_media_lists/:prtimes_media_list_id/media_outlets/delete
 * @export
 * @interface PrtimesMediaListMediaOutletsDeleteResponse
 */
export interface PrtimesMediaListMediaOutletsDeleteResponse {
    /**
     * HTTPステータスコード
     * @type {number}
     * @memberof PrtimesMediaListMediaOutletsDeleteResponse
     */
    status?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof PrtimesMediaListMediaOutletsDeleteResponse
     */
    message?: string;
}

export function PrtimesMediaListMediaOutletsDeleteResponseFromJSON(json: any): PrtimesMediaListMediaOutletsDeleteResponse {
    return PrtimesMediaListMediaOutletsDeleteResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListMediaOutletsDeleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListMediaOutletsDeleteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function PrtimesMediaListMediaOutletsDeleteResponseToJSON(value?: PrtimesMediaListMediaOutletsDeleteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

